<template>
  <div id="app">
    <el-backtop :bottom="100">
      <div
        style="{
        height: 50px;
        width: 50px;
        box-shadow: 0 0 6px rgba(0,0,0, .12);
        text-align: center;
        line-height: 50px;
        color: #1989fa;
      }"
      >
        <img src="./up.svg" alt>
      </div>
    </el-backtop>
    <router-view/>
    <div class="link">
      <div class="container">
        <el-row>
          <el-col :span="8">
            <div class="title">ISE学者评价</div>
            <div class="con">
              <div>
                <a>
                  


                  ISE（Internet Scholar Evaluation）是人大数媒全
                  <br>新推出的开放学者评价模型，以“破五唯”
                  <br>为动机，以学者为中心，代表作为核心，
                  <br>通过开放评价和严谨的人工智能算法所建立的动态学者榜单。
                </a>
              </div>
              <!-- <div>
                  <a>壹学者客户端下载</a>
                </div>
                <div>
                  <a>学界微信小程序</a>
              </div>-->
            </div>
          </el-col>
          <el-col :offset="2" :span="14">
            <el-col :span="12">
              <div class="title">热门产品</div>
              <div class="imgcon">
                <a target="_bank" href="https://www.rdfybk.com" class="imgbox">
                  <img src="./assets/footer/fyk.png" alt="人大复印库">
                  <span class>人大复印库</span>
                </a>
                <!-- <div class="imgbox">
                <img src="./assets/footer/hztg.png" alt="思政荐稿">
                <span class>思政荐稿</span>
                </div>-->
                <a target="_bank" href="https://academia.net" class="imgbox">
                  <img src="./assets/footer/xuejie.png" alt="学界">
                  <span class>学界</span>
                </a>
                <a href="https://www.ascholar.cn" target="_bank" class="imgbox">
                  <img src="./assets/footer/yixuezhe.png" alt="壹学者">
                  <span class>壹学者</span>
                </a>
              </div>
            </el-col>
            <el-col :offset="6" :span="6">
              <div class="title">联系我们</div>
              <div class="con">
                <div>
                  <a>客服电话：010-62515008-8202</a>
                </div>
                <div>
                  <a>邮箱：yixuezhe@rucdm.com</a>
                </div>
                <div>
                  <a>客服微信：xuezhexiaoyi</a>
                </div>
                <div>
                  <a>客服Q Q：1473968721</a>
                </div>
              </div>
            </el-col>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="footer">
      <div class="container">
        <div>
          <a target="_bank" href="https://www.dmr.cn">人大数媒科技（北京）有限公司</a>&nbsp;｜&nbsp;
          <a target="_bank" href="https://www.ruc.edu.cn">中国人民大学</a>&nbsp;｜&nbsp;
          <a target="_bank" href="http://www.zlzx.com.cn">中国人民大学书报资料中心</a>&nbsp;｜&nbsp;
          <a target="_bank" href="http://www.zlzx.com.cn">中国人民大学人文社科学术成果评价研究中心</a>&nbsp;｜&nbsp;
          <a target="_bank" href="http://www.cas.cn">中国科院</a>&nbsp;｜&nbsp;
          <a target="_bank" href="http://www.moe.gov.cn/">教育部</a>
          <!-- <a href>国家新闻出版广电总局</a> -->
        </div>
        <div
          class="copy"
        >Copyright @ 2014-{{nowYear}} 人大数媒科技（北京）有限公司 All rightsreserved 京ICP备12007831号-5</div>
      </div>
    </div>
  </div>
</template>

<script>
function getIseYear() {
  let date = new Date();
  let year = date.getFullYear();
  return year;
}

export default {
  name: "App",
  data() {
    //这里存放数据
    return {
      nowYear: getIseYear()
    };
  }
};
</script>

<style>
@font-face {
  font-family: "iconfont";
  /* project id 1121919 */
  src: url("//at.alicdn.com/t/font_1121919_smhx51q3ac.eot");
  src: url("//at.alicdn.com/t/font_1121919_smhx51q3ac.eot?#iefix")
      format("embedded-opentype"),
    url("//at.alicdn.com/t/font_1121919_smhx51q3ac.woff2") format("woff2"),
    url("//at.alicdn.com/t/font_1121919_smhx51q3ac.woff") format("woff"),
    url("//at.alicdn.com/t/font_1121919_smhx51q3ac.ttf") format("truetype"),
    url("//at.alicdn.com/t/font_1121919_smhx51q3ac.svg#iconfont") format("svg");
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
}
* {
  margin: 0;
  padding: 0;
}
html,
body {
  width: 100%;
  height: 100%;
  color: #333;
}
ul {
  list-style: none;
}
a {
  text-decoration: none;
  cursor: pointer !important;
  transition: 0.2s;
}
a:hover {
  color: #66b1ff !important;
  transition: 0.2s;
}
img {
  vertical-align: top;
  border: none;
}
.clearf:after,
.clearf:before {
  content: "";
  display: block;
  clear: both;
}
.container {
  width: 1200px;
  margin: 0 auto;
  /* text-align: left; */
}

.link {
  background-color: #2e3642;
  padding-top: 70px;
  padding-bottom: 70px;
  min-width: 1200px;
}
.imgbox {
  text-align: center;
  width: 60px;
  display: inline-block;
  margin-right: 40px;
}
.imgbox:last-child {
  margin: 0;
}
.imgbox img {
  margin-bottom: 15px;
}
.imgbox span {
  color: #999;
  font-size: 12px;
}
.link .title {
  color: #fff;
  margin-bottom: 20px;
}
.link .con {
  color: #999999;
  font-size: 12px;
}
.link .con div {
  line-height: 24px;
}
.footer {
  color: #999999;
  background-color: #191c22;
  padding-top: 25px;
  padding-bottom: 25px;
  text-align: center;
  min-width: 1200px;
}
.footer a {
  color: #999999;
  font-size: 14px;
}
.footer .copy {
  margin-top: 10px;
  font-size: 12px;
  color: #666666;
}
.fw {
  color: #4267b2;
  font-size: 14px;
  font-weight: normal;
  float: right;
  cursor: pointer;
}
.no-data {
  text-align: center;
}
.no-data p {
  margin-top: 35px;
  color: #999999;
  font-weight: 600;
  font-size: 16px;
}
.posite {
  position: relative;
}
.new {
  font-size: 10px !important;
  background-color: #ff6100;
  padding: 3px 3px;
  border-radius: 4px;
  color: #fff;
  position: absolute;
  top: -7px;
  right: -25px;
}
.new-2 {
  font-size: 10px;
  background-color: #ff6100;
  padding: 0px 3px;
  border-radius: 4px;
  color: #fff;
  position: absolute;
  height: 20px;
  line-height: 20px;
  top: 12px;
  margin-left: 5px;
}
.el-dialog__title {
  font-weight: bold !important;
}
.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #4267b2 !important;
}
.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #4267b2 !important;
  border-color: #4267b2 !important;
}
.el-dialog__body {
  padding: 30px 20px 50px !important;
}
.el-dialog__header {
  padding: 40px 20px 10px !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue